'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrandBar = function BrandBar() {
    return _react2.default.createElement(
        'div',
        { className: 'brand-bar' },
        _react2.default.createElement(
            'div',
            {
                className: 'brand-bar-inner bg-darker d-flex alig-items-center text-center text-uppercase justify-content-center py-2 fz-2'
            },
            _react2.default.createElement(
                'a',
                {
                    href: 'https://actionnetwork.com/',
                    target: '_blank',
                    className: 'text-white mr-2 dark-gray-text',
                    rel: 'noopener noreferrer'
                },
                'Betting'
            ),
            _react2.default.createElement(
                'svg',
                { width: '30', height: '20', viewBox: '0 0 42 42', xmlns: 'http://www.w3.org/2000/svg' },
                _react2.default.createElement(
                    'g',
                    { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
                    _react2.default.createElement('rect', {
                        stroke: '#00C358',
                        strokeWidth: '1.5',
                        fill: '#22222B',
                        x: '0.75',
                        y: '0.75',
                        width: '40.5',
                        height: '40.5',
                        rx: '20.25'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M22.6747111,21.0669558 C26.6300741,19.5051768 30.7482519,18.4131492 34.937363,17.718232 L33.2452296,20.8862983 C30.8809926,21.1947072 28.6113333,21.6355912 26.3558815,22.213884 L29.0384889,27.6428453 L26.7919556,27.6428453 L24.3877926,22.7853536 C18.2791259,24.509 13.0304741,26.7030276 7,29.9136077 C11.8832,26.3885304 17.075437,23.2792486 22.6747111,21.0669558 Z M22.7197185,19.3842486 L20.872963,15.6530055 L18.0172741,21.4227072 C16.9579407,21.9359171 15.9128148,22.4784144 14.8814815,23.0467348 L20.830237,11 L24.630563,18.691221 C23.9897778,18.9111381 23.3527259,19.1421823 22.7197185,19.3842486 Z',
                        fill: '#F7F8FD'
                    })
                )
            ),
            _react2.default.createElement(
                'a',
                {
                    href: 'https://fantasylabs.com/',
                    className: 'text-white mr-2',
                    rel: 'noopener',
                    style: { marginLeft: 8 }
                },
                'Fantasy'
            )
        )
    );
};

exports.default = BrandBar;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation/BrandBar.js
// module id = 361
// module chunks = 0